import _ from 'lodash';
import { filterDefinitions } from '../models/filters';
import stateCodes from '../assets/data/state-codes.json';
import countryCodes from '../assets/data/iso3-country-names.json';

class FilteringHelper {
  filterResultsText(query, text) {
    let newQuery = _.cloneDeep(query);
    if (newQuery && text) {
      // Copy any existing must clauses
      newQuery.query.bool.must = [
        ...(newQuery.query.bool.must ? newQuery.query.bool.must : []),
      ];
      // Convert text to array if it is not already
      const textArr = Array.isArray(text) ? text : [text];
      // For each string, add a simple_query_string block to the must clause
      textArr.forEach((string) => {
        newQuery.query.bool.must.push({
          simple_query_string: {
            query: string + '*',
            analyze_wildcard: true,
            default_operator: 'AND',
          },
        });
      });
    }
    // Return the new query
    return newQuery;
  }
  filterSemantic(query, filters) {
    let newQuery = _.cloneDeep(query);
    if (newQuery && filters && Object.keys(filters).length > 0) {
      for (const key in filters) {
        if (filters[key] && filters[key].length > 0) {
          // More/less like clicks are sent as documents (positive_docs / negative_docs) so the search
          // service can use each document's stored vector, with its text as the fallback
          const docsKey = `${key}_docs`;
          const docs = filters[key].map((filter) => ({
            id: filter.doc_id,
            text: filter.query,
          }));
          newQuery.query[docsKey] = newQuery.query[docsKey]
            ? [...newQuery.query[docsKey], ...docs]
            : docs;
        }
      }
    }
    return newQuery;
  }
  formatFilter(payload) {
    const { filterValue, filterField, isTooltip, valueOnly, source } = payload;
    if (filterValue && filterField) {
      const filterTypeLabel = filterDefinitions[source][filterField].label;
      let formattedFilterValue = '';
      switch (typeof filterValue) {
        case 'boolean':
          // Boolean -- return filter category only, no need to display filter value
          return filterTypeLabel;
        case 'object':
          if (filterField === 'positive' || filterField === 'negative') {
            // Semantic more/less like
            // Title-only documents have no '.' separator
            const dot = filterValue.query.indexOf('.');
            const endOfTitle = dot === -1 ? filterValue.query.length : dot;
            const title = filterValue.query.slice(0, endOfTitle).trim();
            const abstract = filterValue.query.slice(endOfTitle + 1).trim();
            // If this is a tooltip, include the abstract as well
            const value = isTooltip
              ? `${title}${abstract.length > 0 ? '. ' + abstract + '.' : ''}`
              : title;
            formattedFilterValue = value;
            break;
          } else if (filterField === 'funding_amount') {
            // Format funding amount as currency
            const value = {
              min: filterValue.min.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
              }),
              max: filterValue.max.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
              }),
            };
            formattedFilterValue = `${value.min} - ${value.max}`;
            break;
          } else {
            // Range
            formattedFilterValue = this.formatRangeValues(filterValue);
            break;
          }
        case 'string':
          if (filterDefinitions[source][filterField].countryCode) {
            // Determine if this is an alpha-2 or alpha-3 country code
            const countryCodeField = filterValue.length === 2 ? 'alpha-2' : 'alpha-3';
            // Find country code
            const countryCode = countryCodes.find(
              (country) => country[countryCodeField] === filterValue
            );
            // Return the country name if we have it
            formattedFilterValue = countryCode ? countryCode.name : filterValue;
          } else if (filterDefinitions[source][filterField].stateCode) {
            // State code
            const stateCode = stateCodes.find(
              (state) => state.state_code === filterValue
            );
            formattedFilterValue = stateCode
              ? stateCode.display_name
              : filterValue;
          } else {
            // Format name
            formattedFilterValue = this.formatStringValues(filterValue);
          }
          break;
        default:
          formattedFilterValue = filterValue;
          break;
      }

      if (valueOnly) {
        return formattedFilterValue;
      } else {
        return `${filterTypeLabel}: ${formattedFilterValue}`;
      }
    }
  }
  formatStringValues(string) {
    const acronyms = ['hbcu', 'ngo', 'vc', 'irs', '501c3'];
    // Remove punctuation from name
    let stringSansPunctuation = string
      .replaceAll('_', ' ')
      .replaceAll('-', ' ')
      .replaceAll(',', ', ');
    // Split name into words, capitalize word if acronym else capitalize first letter
    return stringSansPunctuation
      .split(' ')
      .map((word) => {
        if (acronyms.includes(word.toLowerCase())) {
          return word.toUpperCase();
        } else {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }
      })
      .join(' ');
  }
  formatRangeValues(filterValue) {
    const _min = filterValue.min ? filterValue.min : 0;
    const _max = filterValue.max ? filterValue.max : filterValue.max;
    let formattedRangeValues = `${_min + ' - ' + _max}`;
    return formattedRangeValues;
    //`${filterValue.min + ' - ' + filterValue.max}`;
  }
}

export default new FilteringHelper();
